import classes from 'components/common/LodaerSpinner/LoaderSpinner.module.scss';

interface Props {
    className?: string;
}

export const LoaderSpinner = ({ className = '' }: Props) => {
    return <div data-testid={'loader'} className={`${classes.loader} ${className}`} />;
};
